import { PropsWithChildren } from 'react';

import { Box } from '@mui/material';
import { ErrorBoundary } from 'common/hocs/ErrorBoundary';
import {
    Operations
} from 'common/types/TypeDefs';

import { ProfileBar } from './components/ProfileBar';
import { UserProfileEntityContainerProps } from './UserProfileEntityContainerTypeDefs';

export function UserProfileEntityContainer({
    title,
    isCreateButtonDisabled,
    shouldShowCreateButton,
    operationName = Operations.Link,
    containerInlineStyles,
    createButtonHandler,
    children,
    useTitleInfoIcon,
    iconTooltipText,
    includeRefreshButton,
    testId
}: PropsWithChildren<UserProfileEntityContainerProps>) {
    return (
        <Box
            sx={containerInlineStyles}
        >
            <ErrorBoundary>
                <ProfileBar
                    title={title}
                    createButtonName={`+ ${operationName}`}
                    shouldShowCreateButton={shouldShowCreateButton}
                    isCreateButtonDisabled={isCreateButtonDisabled}
                    createButtonOnClick={createButtonHandler}
                    useTitleInfoIcon={useTitleInfoIcon}
                    iconTooltipText={iconTooltipText}
                    includeRefreshButton={includeRefreshButton}
                    testId= {testId}
                />
                {children}
            </ErrorBoundary>
        </Box>
    );
}
